import { normalizeConsentRenewAgree } from '@/common/normalize/normalize-consent-renew-agree'

export const normalizeConsentRenewDisagree = (rawData) => {
  const { isAlreadyAgree } = normalizeConsentRenewAgree(rawData)
  return {
    isAlreadyAgree,
    isAlreadyDisagree: rawData?.is_already_disagree ?? true,
  }
}
